








































































































import { Component, Vue } from "vue-property-decorator";
import AddTransferRegion from "./modals/addTransferRegion.vue";
import UpdateTransferRegion from "./modals/updateTransferRegion.vue";
import Ajax from '../../../lib/ajax';
import TransferRegion from "@/store/entities/transferRegion";
@Component({
  components: { AddTransferRegion, UpdateTransferRegion  },
})
export default class TransferRegions extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  isUpdateModal: boolean = false;
  selectedItem:TransferRegion=new TransferRegion();

  async getRegions(){
    var response = await Ajax.get(
        '/api/services/app/Transfer/GetRegions'
      );
      this.mockData=response.data.result.items;;
  }

  async created() {

  
      this.getRegions();
      this.headers= [
          { text: 'Transfer Bölgesi', value: 'transferRegion' },
          { text: "İşlemler", value: "transactions" }

        ],
   

        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Transfer',disabled: true},
          {text: 'Transfer Bölgeleri',disabled: true}
        
      ]
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

   async confirmDelete(item) {
    this.$swal({
      title: "Satır Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        
        Ajax.delete(
        '/api/services/app/Transfer/DeleteRegion?input=' + item.id
      );

        Vue.$toast.success("Silme Başarılı");

      this.getRegions();
      }
    
  
    });
   
  }

  updateRegion(item) {
    this.selectedItem=item;
    this.isUpdateModal = true;
  }

    closeUpdateModal() {
    this.isUpdateModal = false;
    this.getRegions();
  }



  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
        this.getRegions();

  }

  cancelModal() {
    this.isOpenModal = false;
  }







}
